/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';

/** Components */
import Keypad from './Keypad';
import KeypadButton from './KeypadButton';

class Numpad extends Component {
  render() {
    return (
      <Keypad className="numpad" onKeyPressWrite={this.props.onKeyPressWrite}>
        <div>
          <KeypadButton label="7" />
          <KeypadButton label="8" />
          <KeypadButton label="9" />
        </div>
        <div>
          <KeypadButton label="4" />
          <KeypadButton label="5" />
          <KeypadButton label="6" />
        </div>
        <div>
          <KeypadButton label="1" />
          <KeypadButton label="2" />
          <KeypadButton label="3" />
        </div>
        <div>
          <KeypadButton label="0" />
          <KeypadButton label="." />
          <KeypadButton label="," />
        </div>
      </Keypad>
    );
  }
}

export default Numpad;
